const theme = {
    colors: {
      background: "#FFFFFF", // White background
      text: "#203354", // Text color
      headerBackground1: "#D1E5F4", // Light pastel blue
      headerBackground2: "#AECCE4" // Slightly darker pastel blue
    }
  };
  
  export default theme;  